const cartSlice = (set) => ({
  cart: [],
  laundryCart: [],
  stationaryCart: [],
  cartCount: 0,

  setCart: (input) => set((state) => ({ cart: input })),
  setCartCount: (input) => set((state) => ({ cartCount: input })),
  setLaundryCart: (input) => set((state) => ({ laundryCart: input })),
  setStationaryCart: (input) => set((state) => ({ stationaryCart: input })),
});

export default cartSlice;
